'use strict';
import $ from './vendor/jquery-3.7.1.min.js';

import Sleepy from './classes/sleepy.class.js';
import MainNav from './classes/main-nav.class';
import Tabs from './tabs.js';
import Leaving from './leaving.js';
import Tipped from './vendor/tipped.min.js';
import Instagram from './instagram.js';
import Violator from './violator.js';
// import IsiHeight from './isi-height.js';

const SM = new Sleepy();
// const $ = (el) => document.querySelector(el);


SM.ready(() => {
  new Tabs();
  new Leaving();
  new MainNav('nav.main');
  new Instagram();
  new Violator();
  // new IsiHeight();
  document.getElementsByTagName('body')[0].className = (SM.isTouchDevice()) ? 'touchable' : '';

  // Tooltips
  $(function() {
    const tooltips = document.querySelectorAll('.tooltip');
    if (! tooltips) return;

    for (let q = tooltips.length - 1; q >= 0; --q) {
      const tooltipHTML = `
        <div class="tooltip-wrapper">
          <div class="tooltip-body">
            <h2 class="tooltip-title">${tooltips[q].dataset.tooltipTitle}</h2>

            <p class="tooltip-content">${tooltips[q].dataset.tooltipBody}</p>
          </div>
        </div>
      `;

      Tipped.create(tooltips[q], tooltipHTML, {
        maxWidth: 510,
        skin: 'tecelra',
        close: 'overlap',
        containment: {
          padding: 16
        },
        // hideOn: false
      });
    }
  });

  /* ISI Fixed funtionality */
  const isiFixed = $('.isi-fixed');
  const isi = $('#full-isi');

  const toggleIsi = () => {
    const isiFixedTop = isiFixed.offset().top;
    const isiTop = isi.offset().top;

    if ( isiFixedTop >= isiTop && !isiFixed.hasClass('closed') ) {
      isiFixed.addClass('closed');
    } else if ( isiFixedTop < isiTop && isiFixed.hasClass('closed') ) {
      isiFixed.removeClass('closed');
    }
  };

  toggleIsi();

  isiFixed.on('click', (e) => {
    e.preventDefault();

    window.scroll({
      top: isi.offset().top - 80,
      behavior: 'smooth',
    });
  });

  isi.find('.isi_title').on('click', (e) => {
    e.preventDefault();

    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  });

  if (window.innerHeight <= 756 && window.innerWidth >= 102) {
    isiFixed.addClass('v-small');
  } else {
    isiFixed.removeClass('v-small');
  }

  $(window).on('scroll', function () {
    toggleIsi();
  });
  /* END ISI Fixed funtionality */

});
